import React, { useState } from "react";
import { TiStarFullOutline } from "react-icons/ti";
import Countdown, { zeroPad } from "react-countdown";
import { AiOutlineHeart, AiFillHeart } from "react-icons/ai";
import { postWishList, getWishLists } from "../../redux/cartslice";
import { useDispatch, useSelector } from "react-redux";
import { pushToDataLayer } from "../utils/dataUserpush"
const ProductCard = ({ item, type, type2 }) => {
    const dispatch = useDispatch()
    const [hasError, setHasError] = useState(false);
    const wishListData = useSelector(state => state.cartslice.wishListData);
    const currentcountry = useSelector((state) => state.globalslice.currentcountry);
    const authstatus = useSelector((state) => state.formslice.authstatus);
    
    const handleWishList = async (e, item) => {
        e.preventDefault()
        var input_data = {
            "product_id": item.id,
            "sku": item.hasOwnProperty('sku') ? item.sku : item.url.split("/")[1]
        }
        await dispatch(postWishList(input_data))
        dispatch(getWishLists())
    }

    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            return (
                <p style={{ marginTop: 30, marginBottom: 20 }}>{''}</p>
            );
        } else {
            // Render a countdown
            return (
                <>
                    <p>
                        <img className="timecount-image" src={'/assets/vector_icons/countdown.png'} style={{}} /> {zeroPad(days) + ' h'} : {zeroPad(minutes) + ' m'} : {zeroPad(seconds) + ' s'}
                    </p>
                </>

            );
        }
    };
    const productcard = (cardname) => {
        pushToDataLayer("click_Product_card", currentcountry.name, {
            card_name:cardname
        });
    }


    return (
        <div className='product_container' onClick={()=>productcard(item.name) }>
            {hasError ? (
                <div className="no_image_placeholder">
                </div>
            ) : (
                <img
                    src={item.image}
                    onError={() => setHasError(true)}
                />
            )}

            {
                authstatus &&
                <div className="position-absolute custom_wish_heart" onClick={(e) => handleWishList(e, item)}>
                    {
                        wishListData && wishListData.length > 0 && wishListData.map(({ id }) => id).flat().includes(item.id) ?
                            <AiFillHeart
                                color={'#ff4a4a'}
                                size={20}
                            /> :
                            <AiOutlineHeart
                                size={20}
                                color={'#000'}
                            />

                    }

                </div>
            }


            <div className='product_content'>
                {/* <div className='product_rating_container'>
                    <span>4.1</span>
                    <span><TiStarFullOutline size={12} color={'rgba(64, 184, 98, 1)'} /></span>
                    <span style={{ color: 'rgba(158, 165, 168, 1)' }}>|</span>
                    <span style={{ color: 'rgba(158, 165, 168, 1)' }}>(22)</span>
                </div> */}




                <h3>
                    {item.name}
                </h3>

                <div className='product_price_container'>
                    {
                        item.hasOwnProperty('currency_type') ?
                            <div className='display_price'><span>{currentcountry.currency}</span><h3>{(item.display_price)}</h3></div>
                            :
                            <div className='display_price'><span>{currentcountry.currency}</span><h3>{(item.display_price)}</h3></div>

                    }

                    {
                        item.hasOwnProperty('old_price') &&
                        <div className='d-flex striked_price'>
                            <span>{currentcountry.currency} {item.old_price}</span>
                            <h3>{item.percentage}%OFF</h3>
                        </div>
                    }
                </div>
                {
                    type != 2 && item.countdown != 'Invalid date' && new Date(item.countdown) > new Date() &&
                    <div className="countdown">
                        <Countdown
                            date={item.countdown}
                            renderer={renderer}
                        />
                    </div>
                }
                {
                    type == 2 &&
                    <div className="grab_it_now">
                        <img src={'/assets/vector_icons/grab_it_now_bg.png'} className="background-image" />
                        <div className="overlay-text">GRAB IT NOW!</div>
                    </div>
                }


                {
                    type2 == 1 &&
                    <div className="d-flex align-items-center mb-1">
                        <img src={'/assets/vector_icons/flash.png'} className="selling_fast_img" />
                        <div className="selling_fast_title">Selling out fast</div>
                    </div>
                }
            </div>
        </div>
    )
}

export default ProductCard